<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="voting" @selected="switchTab"></TabsWidget>
      <div class="tab-options"></div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="left-panel-header">
          <div class="left-panel-header-title">
            <span>VOTING SESSIONS</span>
          </div>
          <div class="left-panel-header-option"></div>
        </div>
        <div class="left-panel-body">
          <div class="voting-session-item" v-for="(item, index) in voting_sessions" :key="index"
            @click="selectReport(item)" :class="{
              active: selected_report && selected_report.id == item.id,
            }">
            <div v-if="item.cover_image" class="voting-session-item-cover-image-panel">
              <img :src="$store.state.ASSETS_BASE_URL +
                '/assets/uploaded/' +
                item.cover_image
                " />
            </div>
            <div class="voting-session-item-top-panel">
              <div class="voting-session-item-image">
                <img :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  item.logo
                  " />
              </div>
              <div class="voting-session-item-title">
                <span>{{ item.title }}</span>
              </div>
              <div class="voting-session-item-option"></div>
            </div>
            <div class="voting-session-item-bottom-panel">
              <div class="voting-session-item-bottom-left">
                <div class="voting-session-item-startdate">
                  <b-icon icon="calendar"></b-icon>
                  <span>Start Date:
                    {{
                      moment(item.start_time).format("MMMM Do YYYY, h:mm A")
                    }}</span>
                </div>
                <div class="voting-session-item-enddate">
                  <b-icon icon="calendar"></b-icon>
                  <span>End Date:
                    {{
                      moment(item.end_time).format("MMMM Do YYYY, h:mm A")
                    }}</span>
                </div>
              </div>
              <div class="voting-session-item-bottom-left">
                <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
                <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selected_report" class="rigth-panel active_session">
        <div class="rigth-panel-header">
          <div class="tabs-widget">
            <div class="tab-item" :class="{ active: reportTab == 'overview' }"
              @click="switchReportTab('overview')">OVERVIEW</div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: reportTab == 'transactions' }"
              @click="switchReportTab('transactions')">TRANSACTIONS HISTORY</div>
          </div>
        </div>

        <div class="rigth-panel-body" :class="{ expand: reportTab == 'overview' }"
          v-if="reportTab == 'overview' && reports">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">OVERVIEW</h2>
            <div class="rigth-panel-body-header-actions">
              <b-select v-model="selected_currency" @input="onCurrencyChange" class="filter-currency-input"
                placeholder="Select Currency">
                <option value="RWF">RWF</option>
                <option value="USD">USD</option>
              </b-select>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="rigth-panel-top">
            <widgetCounter title="EARNED (Tax & Topup excluded)" counterTextSize="20px" :value="$formatMoney(
              reports.earned_amount - (reports.topup_amount || 0),
              (decimalCount = 2),
              (decimal = '.'),
              (thousands = ','),
              (currency = selected_currency)
            )
              ">
              <img width="80" src="@/assets/images/dashboard/Graph-3.svg" />
            </widgetCounter>

            <widgetCounter title="TOTAL BALANCE" counterTextSize="20px" :value="$formatMoney(
              reports.tax_balance + reports.earned_amount - (reports.topup_amount || 0),
              (decimalCount = 2),
              (decimal = '.'),
              (thousands = ','),
              (currency = selected_currency)
            )

              ">
              <img width="80" src="@/assets/images/dashboard/Graph-2.svg" />
            </widgetCounter>

            <widgetCounter title="TOTAL PARTICIPANT REWARDS" counterTextSize="20px" :value="$formatMoney(
              reports.total_participant_rewards || 0,
              (decimalCount = 2),
              (decimal = '.'),
              (thousands = ','),
              (currency = selected_currency)
            )
              ">
              <img width="80" src="@/assets/images/dashboard/Graph-1.svg" />
            </widgetCounter>
          </div>

          <BalancePaymentType :currency="selected_currency"
            :cardAmount="(reports.payed_by_card && reports.payed_by_card.total) || 0"
            :momoAmount="(reports.payed_by_momo && reports.payed_by_momo.total) || 0"
            :spennAmount="(reports.payed_by_spenn && reports.payed_by_spenn.total) || 0">
          </BalancePaymentType>
          </div>
        </div>

        <div class="rigth-panel-body" :class="{ expand: reportTab == 'transactions' }"
          v-if="reportTab == 'transactions' && reports">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">
              TRANSACTIONS HISTORY ({{ reports.total_payed }})
            </h2>
            <div class="rigth-panel-body-header-actions">
              <b-select v-model="selected_currency" @input="onCurrencyChange" class="filter-currency-input"
                placeholder="Select Currency">
                <option value="RWF">RWF</option>
                <option value="USD">USD</option>
              </b-select>
              <b-button v-if="reports.transactions.length > 0" type="is-default" outlined :loading="loading_download"
                @click="downloadTransationReport()">DOWNLOAD HISTORY</b-button>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="table-widget" v-if="reports.transactions.length > 0">
              <table>
                <tr>
                  <th class="stick-th">Identifier</th>
                  <th class="stick-th">Transaction ID</th>
                  <th class="stick-th">Payed With</th>
                  <th class="stick-th">Amount</th>
                  <th class="stick-th">Eaned</th>
                  <th class="stick-th">Tax</th>
                  <th class="stick-th">Status</th>
                  <th class="stick-th">Date</th>
                </tr>

                <template v-for="(item, index) in reports.transactions">
                  <tr v-if="!loading_transation_report" :key="index">
                    <td>
                      {{
                        item.payment_type == "CARD"
                          ? item.bill_to_first_name +
                          " " +
                          item.bill_to_last_name
                          : item.bill_to_phone
                      }}
                    </td>
                    <td>{{ item.transactionid }}</td>
                    <td>{{ item.payment_type }}</td>
                    <td>
                      {{
                        $formatMoney(
                          item.amount,
                          (decimalCount = 2),
                          (decimal = "."),
                          (thousands = ","),
                          (currency = selected_currency)
                        )
                      }}
                    </td>

                    <td>
                      {{
                        $formatMoney(
                          item.earned,
                          (decimalCount = 2),
                          (decimal = "."),
                          (thousands = ","),
                          (currency = selected_currency)
                        )
                      }}
                    </td>

                    <td>
                      {{
                        $formatMoney(
                          item.tax,
                          (decimalCount = 2),
                          (decimal = "."),
                          (thousands = ","),
                          (currency = selected_currency)
                        )
                      }}
                    </td>

                    <td>
                      <b-tag class="tag-option" type="is-success">PAYED</b-tag>
                    </td>
                    <td>
                      {{
                        moment(item.created_at).format("MMM DD YYYY, h:mm A")
                      }}
                    </td>
                  </tr>
                </template>

                <template v-for="(item, index) in 15">
                  <tr v-if="loading_transation_report" :key="index">
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                  </tr>
                </template>
              </table>
            </div>

            <widgetNotfound v-if="reports.transactions.length == 0 && !loading_transation_report
            " title="No transactions found" subtitle="No transactions found for this report"></widgetNotfound>
          </div>
        </div>
      </div>
      <div v-else class="rigth-panel">
        <widgetNotfound title="No report" subtitle="Please select a voting session to view report"></widgetNotfound>
      </div>
    </div>
  </div>
</template>

<script>
import TabsWidget from "./components/TabsWidget.vue";
import BalancePaymentType from "./components/BalancePaymentType.vue";
export default {
  components: {
    TabsWidget,
    BalancePaymentType
  },
  sockets: {},
  data: () => ({
    loading_voting_session: false,
    voting_sessions: [],
    selected_report: null,
    reports: {
      tax_balance: 0,
      earned_amount: 0,
      total_payed: 0,
      topup_amount: 0,
      total_participant_rewards: 0,
      payed_by_card: { total: 0 },
      payed_by_momo: { total: 0 },
      payed_by_spenn: { total: 0 },
      transactions: [],
    },
    loading_download: false,
    selected_currency: "RWF",
    reportTab: "overview",
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getMyVotingSessions();
  },
  methods: {
    resetSession() {
      let vm = this;
      vm.selected_report = null;
      vm.reportTab = "overview";
    },
    switchReportTab(tab) {
      let vm = this;
      vm.reportTab = tab;
    },
    downloadTransationReport() {
      let vm = this;
      vm.loading_download = true;
      vm.$store
        .dispatch("ADMIN_USER_DOWNLOAD_TRANSATION_REPORT", {
          stream_id: vm.selected_report.id,
          type: "voting",
        })
        .then((response) => {
          vm.loading_download = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Report downloaded successfully",
          });
          // Save cvs file from response
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "text/csv",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            vm.selected_report.title + " transactions history report.csv"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.loading_download = false;
          console.log(error);
        });
    },
    onCurrencyChange() {
      let vm = this;
      vm.selectReport(vm.selected_report);
    },
    selectReport(item) {
      let vm = this;
      vm.loading_transation_report = true;
      vm.selected_report = item;
      vm.$store
        .dispatch("ADMIN_USER_TRANSATION_REPORT", {
          id: item.id,
          type: "voting",
          currency: vm.selected_currency
        })
        .then((response) => {
          vm.loading_transation_report = false;
          vm.reports = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_transation_report = false;
        });
    },
    getMyVotingSessions() {
      let vm = this;
      vm.loading_voting_session = true;
      vm.$store
        .dispatch("VOTING_GET_MY_VOTING_SESSIONS")
        .then((response) => {
          vm.loading_voting_session = false;
          vm.voting_sessions = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_voting_session = false;
        });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./styles/mobile-panel.scss";

.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: 35% 65%;
    @include dashboard-wrapper-body-mobile;

    @media (max-width: 860px) {
      grid-template-columns: 40% 60%;
    }

    @media (max-width: 638px) {
      grid-template-columns: 100%;
    }

    .left-panel {
      height: 100%;
      // width: 400px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
        background: #fff;

        .left-panel-header-title {
          font-size: 14px;
          font-weight: 600;
        }

        .left-panel-header-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .left-panel-body {
        overflow-y: auto;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;

        .voting-session-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;
          cursor: pointer;
          margin-bottom: 10px;

          &:hover {
            background: #fff;
          }

          &.active {
            background: #fff;
          }

          .voting-session-item-cover-image-panel {
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .voting-session-item-top-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-image {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .voting-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .voting-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }
          }

          .voting-session-item-body-panel {
            padding: 0px 10px;
          }

          .voting-session-item-bottom-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-bottom-left {
              display: flex;
              flex-direction: column;

              .voting-session-item-startdate,
              .voting-session-item-enddate {
                font-size: 12px;
                color: #333;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
              }
            }

            .voting-session-item-bottom-right {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }

    .rigth-panel {
      // width: calc(100% - 400px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      overflow-y: auto;
      @include dashboard-right-panel-mobile;

      .rigth-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 20px;
        border-bottom: 1px solid #ddd;
        border-top: 1px solid #ddd;
        justify-content: space-between;
        position: sticky;
        top: 0;
        background: white;

        .tabs-widget {
          display: flex;
          align-items: flex-end;

          .h-spacer {
            margin-right: 20px;
          }

          .tab-item {
            cursor: pointer;
            padding: 14px 4px;
            white-space: nowrap;

            &.active {
              color: var(--wecodefy-secondary-color, #9fc953);
              border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
            }
          }
        }
      }

      .rigth-panel-top {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 10px;
        padding: 10px;

        @media (max-width: 1100px) {
          grid-template-columns: repeat(2, 1fr);
        }

        @media (max-width: 860px) {
          grid-template-columns: 100%;
        }
      }

      .rigth-panel-body {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;

        &.expand {
          flex: 1;
        }

        .rigth-panel-body-body {
          // height: calc(100% - 60px);
          overflow-y: auto;

          .table-widget {
            table {
              width: 100%;

              tr {
                th {
                  white-space: nowrap;
                }

                td {
                  white-space: nowrap;

                  .tag-lists {
                    display: flex;
                    width: fit-content;
                    flex-shrink: 0;
                    min-width: 170px;
                  }
                }
              }
            }
          }

          .stick-th {
            position: sticky;
            top: 0px;
            background: #fff;
            z-index: 1;
            border-bottom: 1px solid #ddd;
          }
        }
      }
    }
  }
}
</style>
